import {
	OctAutocompleteObject,
	OctLabel,
	OctTableCustom,
	OctTextField,
} from "@oceantech/oceantech-ui";
import { ChangeEvent, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { ModalBaseProps } from "../../../utils/models";
import { MEDICAL_RECORD_SELECT_COLUMNS } from "../../constants/columns";

type Props = ModalBaseProps & {};

const MedicalRecordEditModal = ({ open, onClose }: Props) => {
	const [query, setQuery] = useState<any>({});

	return (
		<Modal show={open} size="lg" centered onHide={onClose}>
			<Modal.Header className="py-3" closeButton>
				<Modal.Title>Thêm mới bệnh án</Modal.Title>
			</Modal.Header>

			<Modal.Body className="bg-white">
				<Row>
					<Col md={4}>
						<OctLabel label="Mã bệnh nhân" />
						<OctTextField
							name="patientCode"
							value={query?.patientName}
							onChange={(e: ChangeEvent<HTMLInputElement>) => {
								setQuery({
									...query,
									patientCode: e.target.value,
								});
							}}
						/>
					</Col>
					<Col md={8}>
						<OctLabel label="Mẫu bệnh án" />
						<OctAutocompleteObject
							options={[]}
							name="template"
							value={query?.template}
							onChange={(selectedOption) => {
								setQuery({
									...query,
									template: selectedOption,
								});
							}}
						/>
					</Col>
				</Row>
				<OctTableCustom
					data={[
						{
							order: 1,
							code: "123456789",
							department: "Khoa nội tiết",
							date: new Date(),
							selected: true,
						},
						{
							order: 2,
							code: "123456789",
							department: "Khoa nội tiết",
							date: new Date(),
							selected: false,
						},
					]}
					columns={MEDICAL_RECORD_SELECT_COLUMNS}
					className="spaces p-0 h-250 mt-8"
					selectionMode={undefined}
					tableOptions={{
						onActionButtonClick: () => {},
					}}
				/>
			</Modal.Body>

			<Modal.Footer>
				<Button className="btn-danger" onClick={onClose}>
					Đóng
				</Button>
				<Button className="btn-fill" onClick={onClose}>
					Tạo bệnh án
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default MedicalRecordEditModal;
